import React from 'react'
import { Button, Progress } from 'antd'
import CustomTable from '../../../elements/Table/CustomTable'
import { Link } from 'react-router-dom'
import { strVal } from '../../../modules/Utils'

const columns = [
  {
    Header: 'Code',
    accessor: 'code',
    zIndex: -10,
    Cell: ({ value, original }) => {
      return (
        <Link
          to={{
            pathname: `/programs/${strVal(original, '_key')}/view`,
          }}>
          {value}
        </Link>
      )
    },
  },
  {
    Header: 'Title',
    accessor: 'program.title',
    zIndex: -9,
  },
  {
    Header: 'Status',
    accessor: 'status',
    zIndex: 999,
  },
  {
    Header: 'Completion',
    accessor: 'completion',
    Cell: ({ value }) => {
      const progressColor =
        value > 40 && value < 100
          ? '#154DE1'
          : value === 100
          ? '#15E16F'
          : '#E13915'
      return (
        <Progress percent={value} size="small" strokeColor={progressColor}/>
      )
    },
  },
]

function List (props) {
  const { list, fetch, fetching, onShow } = props
  return (
    <CustomTable
      CreateButton={() => (
        <Button type="primary" icon={'plus'} size={'small'} onClick={onShow}>
          New
        </Button>
      )}
      columns={columns}
      data={list}
      fetch={fetch}
      fetching={fetching}
    />
  )
}

export default List
